import createStore from '../libs/create-store'
import { generateUUID } from '../libs/uuid'
import { ToastItem, ToastItemOptions } from '../primitives/components/snackbar'

const toastStore = createStore<Record<string, ToastItem>>({})

export default {
    ...toastStore,
    updateToast: (data: ToastItemOptions, id?: string) => {
        const _id = id || generateUUID()
        toastStore.set({
            ...toastStore.get(),
            [_id]: {
                ...data,
                id: _id,
                timestamp: data.timestamp || new Date(),
            },
        })
    },
    removeToast: (id: string) => {
        const { [id]: remove, ...state } = toastStore.get()
        toastStore.set({ ...state })
    },
    hideToast: (id: string) => {
        const state = toastStore.get()
        const toast = state[id]
        if (!toast)
            return

        toastStore.set({ ...state, [id]: { ...toast, visible: false } })
    },
    markAllRead: () => {
        const state = toastStore.get()
        toastStore.set(
            Object.fromEntries(
                Object.entries(state).map(([id, toast]) => [id, { ...toast, read: true }])
            )
        )
    },
}
